import {
  SM_ADMIN_GET_LISTINGS_REQUEST, SM_ADMIN_GET_LISTINGS_SUCCESS, SM_ADMIN_GET_LISTINGS_FAIL,
  SM_ADMIN_GET_LISTING_DETAIL_REQUEST, SM_ADMIN_GET_LISTING_DETAIL_SUCCESS, SM_ADMIN_GET_LISTING_DETAIL_FAIL,
  SM_ADMIN_APPROVE_LISTING_REQUEST, SM_ADMIN_APPROVE_LISTING_SUCCESS, SM_ADMIN_APPROVE_LISTING_FAIL,
  SM_ADMIN_REJECT_LISTING_REQUEST, SM_ADMIN_REJECT_LISTING_SUCCESS, SM_ADMIN_REJECT_LISTING_FAIL,
  SM_ADMIN_GET_TRANSACTIONS_REQUEST, SM_ADMIN_GET_TRANSACTIONS_SUCCESS, SM_ADMIN_GET_TRANSACTIONS_FAIL,
  SM_ADMIN_GET_CONFIG_REQUEST, SM_ADMIN_GET_CONFIG_SUCCESS, SM_ADMIN_GET_CONFIG_FAIL,
  SM_ADMIN_UPDATE_CONFIG_REQUEST, SM_ADMIN_UPDATE_CONFIG_SUCCESS, SM_ADMIN_UPDATE_CONFIG_FAIL,
  SM_ADMIN_DASHBOARD_REQUEST, SM_ADMIN_DASHBOARD_SUCCESS, SM_ADMIN_DASHBOARD_FAIL,
} from "../constants/secondaryMarketConstants";

const initialState = {
  listings: { items: [], pagination: {}, loading: false, error: null },
  listingDetail: { data: null, loading: false, error: null },
  transactions: { items: [], pagination: {}, loading: false, error: null },
  config: { data: null, loading: false, updating: false, error: null },
  dashboard: { data: null, loading: false, error: null },
  approving: false,
  rejecting: false,
};

export const secondaryMarketReducer = (state = initialState, action) => {
  switch (action.type) {
    // Listings
    case SM_ADMIN_GET_LISTINGS_REQUEST:
      return { ...state, listings: { ...state.listings, loading: true, error: null } };
    case SM_ADMIN_GET_LISTINGS_SUCCESS:
      return { ...state, listings: { items: action.payload.data, pagination: action.payload.pagination, loading: false, error: null } };
    case SM_ADMIN_GET_LISTINGS_FAIL:
      return { ...state, listings: { ...state.listings, loading: false, error: action.payload } };

    // Listing Detail
    case SM_ADMIN_GET_LISTING_DETAIL_REQUEST:
      return { ...state, listingDetail: { ...state.listingDetail, loading: true, error: null } };
    case SM_ADMIN_GET_LISTING_DETAIL_SUCCESS:
      return { ...state, listingDetail: { data: action.payload, loading: false, error: null } };
    case SM_ADMIN_GET_LISTING_DETAIL_FAIL:
      return { ...state, listingDetail: { ...state.listingDetail, loading: false, error: action.payload } };

    // Approve
    case SM_ADMIN_APPROVE_LISTING_REQUEST:
      return { ...state, approving: true };
    case SM_ADMIN_APPROVE_LISTING_SUCCESS:
      return { ...state, approving: false };
    case SM_ADMIN_APPROVE_LISTING_FAIL:
      return { ...state, approving: false };

    // Reject
    case SM_ADMIN_REJECT_LISTING_REQUEST:
      return { ...state, rejecting: true };
    case SM_ADMIN_REJECT_LISTING_SUCCESS:
      return { ...state, rejecting: false };
    case SM_ADMIN_REJECT_LISTING_FAIL:
      return { ...state, rejecting: false };

    // Transactions
    case SM_ADMIN_GET_TRANSACTIONS_REQUEST:
      return { ...state, transactions: { ...state.transactions, loading: true, error: null } };
    case SM_ADMIN_GET_TRANSACTIONS_SUCCESS:
      return { ...state, transactions: { items: action.payload.data, pagination: action.payload.pagination, loading: false, error: null } };
    case SM_ADMIN_GET_TRANSACTIONS_FAIL:
      return { ...state, transactions: { ...state.transactions, loading: false, error: action.payload } };

    // Config — GET
    case SM_ADMIN_GET_CONFIG_REQUEST:
      return { ...state, config: { ...state.config, loading: true, error: null } };
    case SM_ADMIN_GET_CONFIG_SUCCESS:
      return { ...state, config: { ...state.config, data: action.payload, loading: false, error: null } };
    case SM_ADMIN_GET_CONFIG_FAIL:
      return { ...state, config: { ...state.config, data: null, loading: false, error: action.payload } };

    // Config — UPDATE
    case SM_ADMIN_UPDATE_CONFIG_REQUEST:
      return { ...state, config: { ...state.config, updating: true, error: null } };
    case SM_ADMIN_UPDATE_CONFIG_SUCCESS:
      return { ...state, config: { ...state.config, data: action.payload, updating: false, error: null } };
    case SM_ADMIN_UPDATE_CONFIG_FAIL:
      return { ...state, config: { ...state.config, updating: false, error: action.payload } };

    // Dashboard
    case SM_ADMIN_DASHBOARD_REQUEST:
      return { ...state, dashboard: { ...state.dashboard, loading: true, error: null } };
    case SM_ADMIN_DASHBOARD_SUCCESS:
      return { ...state, dashboard: { data: action.payload, loading: false, error: null } };
    case SM_ADMIN_DASHBOARD_FAIL:
      return { ...state, dashboard: { ...state.dashboard, loading: false, error: action.payload } };

    default:
      return state;
  }
};

export default secondaryMarketReducer;
